<div class="remit-import" [class.remit-import--expanded]="expanded" *ngIf="enabled && customer">
	<div class="remit-header" (click)="toggle()" [class.is-open]="open">
		<i class="material-icons remit-header__icon">receipt_long</i>
		<div class="remit-header__text">
			<span class="remit-header__title">Import Remittance</span>
			<span class="remit-header__sub">Match a payment advice to open invoices and post one receipt</span>
		</div>
		<span class="remit-header__step" *ngIf="open && mode === 'review' && batch">{{ includedCount }} of {{ batch.recon.line_count }} selected</span>
		<i class="material-icons remit-header__rematch" *ngIf="open && mode === 'review' && batch"
			[class.is-spinning]="parsing"
			(click)="$event.stopPropagation(); retry()"
			matTooltip="Re-match — re-read &amp; re-match without re-uploading">replay</i>
		<i class="material-icons remit-header__clear" *ngIf="open && (batch || pasteText || fileName)"
			(click)="$event.stopPropagation(); reset()"
			matTooltip="Clear — discard and start over">refresh</i>
		<i class="material-icons remit-header__expand" *ngIf="open"
			(click)="$event.stopPropagation(); toggleExpand()"
			[matTooltip]="expanded ? 'Exit focus' : 'Focus mode'">{{ expanded ? 'close_fullscreen' : 'open_in_full' }}</i>
		<i class="material-icons remit-header__chev">{{ open ? 'expand_less' : 'expand_more' }}</i>
	</div>

	<div class="remit-body" *ngIf="open">

		<!-- STEP 1: input -->
		<ng-container *ngIf="mode === 'input'">
			<div class="remit-progress" *ngIf="parsing">
				<div class="remit-progress__spin"></div>
				<div class="remit-progress__text">
					<div class="remit-progress__title">{{ parsingLabel }}</div>
					<div class="remit-progress__sub">{{ parsingSub }}</div>
				</div>
				<div class="remit-progress__bar"><span></span></div>
			</div>

			<div class="remit-input" [class.is-hidden]="parsing">
				<div class="remit-input__pane">
					<div class="remit-input__label">Paste remittance text</div>
					<mat-form-field appearance="outline" class="full-width">
						<textarea matInput rows="9" [(ngModel)]="pasteText"
							placeholder="Paste the remittance rows — reference / vendor ref / date / amount…"></textarea>
					</mat-form-field>
				</div>

				<div class="remit-input__or"><span>or</span></div>

				<div class="remit-input__pane">
					<div class="remit-input__label">Upload a file</div>
					<label class="dropzone" [class.dropzone--active]="dragging" [class.dropzone--filled]="fileName"
						(dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
						<i class="material-icons">{{ fileName ? 'description' : (dragging ? 'file_download' : 'cloud_upload') }}</i>
						<span *ngIf="!fileName" class="dropzone__hint">Drop a <b>PDF</b>, <b>Excel</b>, or <b>CSV</b> here<br><span class="dropzone__sub">or click to browse</span></span>
						<span *ngIf="fileName" class="dropzone__file">{{ fileName }}</span>
						<button *ngIf="fileName" type="button" mat-icon-button class="dropzone__remove"
							(click)="$event.preventDefault(); $event.stopPropagation(); clearFile()"><i class="material-icons">close</i></button>
						<input type="file" accept=".pdf,.csv,.tsv,.txt,.xlsx,.xls" (change)="onFile($event); $event.target.value=''" hidden>
					</label>
				</div>
			</div>

			<div class="remit-foot" [class.is-hidden]="parsing">
				<span class="remit-foot__note">Nothing posts until you review the matches.</span>
				<button mat-raised-button color="primary" [disabled]="!canParse()" (click)="parse()">
					<i class="material-icons">auto_awesome</i>
					Parse &amp; Match
				</button>
			</div>
		</ng-container>

		<!-- STEP 2: review -->
		<ng-container *ngIf="mode === 'review' && batch">
			<div class="remit-summary">
				<div class="remit-summary__totals">
					<div class="stat">
						<span class="stat__label">Remittance total</span>
						<span class="stat__value">{{ statedTotal | currency }}</span>
					</div>
					<i class="material-icons stat__arrow">chevron_right</i>
					<div class="stat">
						<span class="stat__label">Posting</span>
						<span class="stat__value stat__value--accent stat__value--edit">
							<span class="stat__cur">$</span>
							<input type="number" step="0.01" min="0" class="stat__input" [value]="willPostTotal"
								(input)="setPostTotal($event.target.value)"
								matTooltip="Total the receipt will bank. Raise it to the full cash received; the amount above what's applied to invoices is left open as a credit on the customer.">
						</span>
						<span class="stat__sub">{{ includedCount }} of {{ batch.recon.line_count }} lines<ng-container *ngIf="onAccountAmount > 0"> · {{ onAccountAmount | currency }} on account</ng-container></span>
					</div>
					<div class="stat stat--delta" *ngIf="delta !== 0">
						<span class="stat__label">Difference</span>
						<span class="stat__value stat__value--warn">{{ delta | currency }}</span>
					</div>
					<div class="remit-summary__ok" *ngIf="delta === 0 && includedCount">
						<i class="material-icons">check_circle</i> Balances to remittance
					</div>
				</div>
				<div class="remit-summary__right">
					<div class="remit-summary__exports">
						<button mat-stroked-button (click)="exportXlsx()"><i class="material-icons">table_view</i> Excel</button>
						<button mat-stroked-button (click)="exportPdf()"><i class="material-icons">picture_as_pdf</i> PDF</button>
					</div>
					<div class="remit-summary__chips">
						<span class="chip chip--btn st-action" [class.chip--active]="filterStatus==='action'" *ngIf="actionCount" (click)="setFilter('action')">
							<b>{{ actionCount }}</b> need action<span class="chip__amt">{{ actionTotal | currency }}</span></span>
						<span class="chip chip--btn st-all" [class.chip--active]="!filterStatus" (click)="filterStatus=null">
							<b>all</b> {{ batch.recon.line_count }}<span class="chip__amt">{{ statusTotal(null) | currency }}</span></span>
						<span class="chip chip--btn st-matched" [class.chip--active]="filterStatus==='matched'" *ngIf="batch.recon.counts.matched" (click)="setFilter('matched')">
							<b>{{ batch.recon.counts.matched }}</b> matched<span class="chip__amt">{{ statusTotal('matched') | currency }}</span></span>
						<span class="chip chip--btn st-partial" [class.chip--active]="filterStatus==='partial'" *ngIf="batch.recon.counts.partial" (click)="setFilter('partial')">
							<b>{{ batch.recon.counts.partial }}</b> partial<span class="chip__amt">{{ statusTotal('partial') | currency }}</span></span>
						<span class="chip chip--btn st-over" [class.chip--active]="filterStatus==='over'" *ngIf="batch.recon.counts.over" (click)="setFilter('over')">
							<b>{{ batch.recon.counts.over }}</b> over<span class="chip__amt">{{ statusTotal('over') | currency }}</span></span>
						<span class="chip chip--btn st-multiple" [class.chip--active]="filterStatus==='multiple'" *ngIf="batch.recon.counts.multiple" (click)="setFilter('multiple')">
							<b>{{ batch.recon.counts.multiple }}</b> multiple<span class="chip__amt">{{ statusTotal('multiple') | currency }}</span></span>
						<span class="chip chip--btn st-settled" [class.chip--active]="filterStatus==='already_settled'" *ngIf="batch.recon.counts.already_settled" (click)="setFilter('already_settled')">
							<b>{{ batch.recon.counts.already_settled }}</b> settled<span class="chip__amt">{{ statusTotal('already_settled') | currency }}</span></span>
						<span class="chip chip--btn st-credit" [class.chip--active]="filterStatus==='credit'" *ngIf="batch.recon.counts.credit" (click)="setFilter('credit')">
							<b>{{ batch.recon.counts.credit }}</b> credit<span class="chip__amt">{{ statusTotal('credit') | currency }}</span></span>
						<span class="chip chip--btn st-unmatched" [class.chip--active]="filterStatus==='unmatched'" *ngIf="batch.recon.counts.unmatched" (click)="setFilter('unmatched')">
							<b>{{ batch.recon.counts.unmatched }}</b> unmatched<span class="chip__amt">{{ statusTotal('unmatched') | currency }}</span></span>
					</div>
				</div>
			</div>

			<div class="remit-tabletools">
				<div class="remit-search">
					<i class="material-icons">search</i>
					<input type="text" [(ngModel)]="searchText" placeholder="Find ref, invoice, amount, or note…">
					<i class="material-icons remit-search__clear" *ngIf="searchText" (click)="searchText=''">close</i>
				</div>
				<span class="remit-tabletools__count">{{ filteredLines.length }} of {{ batch.recon.line_count }}</span>
			</div>

			<div class="table-wrap">
				<table class="remit-table">
					<thead>
						<tr>
							<th class="col-post">
								<mat-checkbox [checked]="allSelected" (change)="toggleAll()" matTooltip="Select all matched"></mat-checkbox>
							</th>
							<th class="th-sort" (click)="setSort('vendor_ref')">Vendor Ref<i class="material-icons th-arrow" *ngIf="sortKey==='vendor_ref'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
							<th>Description</th>
							<th class="num th-sort" (click)="setSort('paid_amount')">Paid<i class="material-icons th-arrow" *ngIf="sortKey==='paid_amount'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
							<th class="th-sort" (click)="setSort('matched_transno')">Invoice<i class="material-icons th-arrow" *ngIf="sortKey==='matched_transno'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
							<th class="num th-sort" (click)="setSort('matched_balance')">Balance<i class="material-icons th-arrow" *ngIf="sortKey==='matched_balance'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
							<th class="th-sort" (click)="setSort('match_status')">Status<i class="material-icons th-arrow" *ngIf="sortKey==='match_status'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
							<th class="num th-sort" (click)="setSort('alloc_amount')">Allocate<i class="material-icons th-arrow" *ngIf="sortKey==='alloc_amount'">{{ sortDir===1 ? 'arrow_upward' : 'arrow_downward' }}</i></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let line of filteredLines" [class.excluded]="!line.include" [class.unmatchable]="!line.matched_debtortransid">
							<td class="col-post"><mat-checkbox [checked]="line.include" (change)="toggleInclude(line)" [disabled]="!isSelectable(line)"></mat-checkbox></td>
							<td class="mono">{{ line.vendor_ref }}</td>
							<td class="desc" [title]="line.description">{{ line.description || '—' }}</td>
							<td class="num">{{ line.paid_amount | currency }}</td>
							<td class="mono">{{ line.matched_transno || '—' }}</td>
							<td class="num">{{ line.matched_balance !== null ? (line.matched_balance | currency) : '—' }}</td>
							<td>
								<span class="chip" [ngClass]="statusClass(line.match_status)" [class.chip--btn]="hasDetail(line.match_status)"
									[matTooltip]="hasDetail(line.match_status) ? 'Click for details' : line.match_note"
									(click)="openDetail(line)">
									{{ statusLabel(line.match_status) }}<i *ngIf="hasDetail(line.match_status)" class="material-icons chip__i">info</i>
								</span>
								<span class="row-gap" *ngIf="lineGap(line)">{{ lineGap(line) }}</span>
							</td>
							<td class="num">
								<input type="number" step="0.01" class="alloc-input" [value]="line.alloc_amount"
									(change)="updateAlloc(line, $event.target.value)" [disabled]="!line.include">
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="remit-receipt">
				<div class="remit-receipt__title">Receipt details</div>
				<div class="remit-receipt__fields">
					<mat-form-field appearance="outline">
						<mat-label>Bank account</mat-label>
						<mat-select [(value)]="header.bankaccount">
							<mat-option *ngFor="let b of bankaccounts" [value]="b.accountcode">{{ b.bankaccountname }}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline">
						<mat-label>Method</mat-label>
						<mat-select [(value)]="header.payment_type">
							<mat-option *ngFor="let m of payment_methods" [value]="m.paymentid">{{ m.paymentname }}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline">
						<mat-label>Date</mat-label>
						<input matInput [matDatepicker]="rpick" [(ngModel)]="header.datepaid">
						<mat-datepicker-toggle matSuffix [for]="rpick"></mat-datepicker-toggle>
						<mat-datepicker #rpick></mat-datepicker>
					</mat-form-field>
					<mat-form-field appearance="outline">
						<mat-label>Reference</mat-label>
						<input matInput [(ngModel)]="header.reference">
					</mat-form-field>
					<mat-form-field appearance="outline">
						<mat-label>Notes</mat-label>
						<input matInput [(ngModel)]="header.notes">
					</mat-form-field>
				</div>
				<div class="remit-receipt__hint" *ngIf="onAccountAmount > 0">
					<i class="material-icons">info</i>
					{{ onAccountAmount | currency }} above the applied invoices will be banked and left open as a credit on the customer account.
				</div>
			</div>

			<div class="remit-foot">
				<span class="remit-foot__note">{{ filterStatus ? 'Filtered view — posting still applies all included lines.' : '' }}</span>
				<button mat-button (click)="reset()">Cancel</button>
				<div class="remit-foot__total"
					matTooltip="Total the receipt will bank. Raise it to the full check amount; anything above what's applied to invoices is left open as a credit on the customer.">
					<span class="remit-foot__total-label">Receipt total</span>
					<span class="remit-foot__total-box">
						<span class="remit-foot__cur">$</span>
						<input type="number" step="0.01" min="0" class="remit-foot__input"
							[value]="willPostTotal" (input)="setPostTotal($event.target.value)">
					</span>
				</div>
				<button mat-raised-button color="primary" [disabled]="posting || willPostTotal <= 0" (click)="post()">
					<i class="material-icons">check</i>
					<span *ngIf="!posting">Post Receipt</span>
					<span *ngIf="posting">Posting…</span>
				</button>
			</div>
		</ng-container>

		<!-- STEP 3: done -->
		<ng-container *ngIf="mode === 'done' && result">
			<div class="done-box">
				<i class="material-icons">check_circle</i>
				<div class="done-box__text">
					<h4>Receipt {{ result.receipt_transno }} posted</h4>
					<p>{{ result.total | currency }} across {{ result.allocated?.length || 0 }} invoices · journal {{ result.journal_no }}</p>
				</div>
				<button mat-raised-button color="primary" (click)="reset()">Import another</button>
			</div>
		</ng-container>

	</div>

	<!-- line detail modal -->
	<div class="remit-modal" *ngIf="detailLine" (click)="closeDetail()">
		<div class="remit-modal__card" (click)="$event.stopPropagation()">
			<div class="remit-modal__head">
				<span class="remit-modal__title">Vendor Ref <b>{{ detailLine.vendor_ref }}</b></span>
				<span class="chip" [ngClass]="statusClass(detailLine.match_status)">{{ statusLabel(detailLine.match_status) }}</span>
				<button type="button" class="remit-modal__x" (click)="closeDetail()"><i class="material-icons">close</i></button>
			</div>
			<div class="remit-modal__body">
				<div *ngIf="detailLoading" class="remit-modal__muted">Loading…</div>
				<div *ngIf="!detailLoading && detailData?.error" class="remit-modal__muted">{{ detailData.error }}</div>

				<ng-container *ngIf="!detailLoading && detailData && !detailData.error">
					<div class="remit-modal__amt">
						<span class="remit-modal__amt-l">Remittance amount</span>
						<b>{{ detailLine.paid_amount | currency }}</b>
					</div>

					<p *ngIf="detailLine.match_status === 'credit' && detailData.credit_notes?.length" class="remit-modal__hint">
						Credit the customer deducted — not cash, excluded from the receipt. Backed by:
					</p>

					<!-- credit note(s) -->
					<div *ngFor="let cr of detailData.credit_notes" class="doc">
						<div class="doc__hd">
							<span class="doc__title">Credit note #{{ cr.transno }}</span>
							<span class="doc__meta">{{ cr.date }} · {{ cr.face | currency }}<span *ngIf="cr.reference"> · {{ cr.reference }}</span></span>
							<span class="chip" [ngClass]="cr.settled ? 'st-settled' : 'st-matched'">{{ cr.settled ? 'applied' : 'open' }}</span>
						</div>
						<div class="doc__rows" *ngIf="cr.applied_to?.length">
							<div class="drow" *ngFor="let a of cr.applied_to">
								<span class="drow__date">{{ a.date }}</span>
								<span class="drow__by">Applied to invoice</span>
								<span class="drow__ref">#{{ a.transno }}</span>
								<span class="drow__amt">{{ a.amount | currency }}</span>
							</div>
						</div>
						<div *ngIf="!cr.applied_to?.length" class="remit-modal__muted doc__empty">Open credit — not yet applied.</div>
					</div>
					<div *ngIf="detailLine.match_status === 'credit' && !detailData.credit_notes?.length" class="remit-modal__muted">
						No matching credit note found for {{ detailLine.vendor_ref }}.
					</div>

					<!-- invoice(s) -->
					<div *ngIf="detailLine.match_status !== 'credit' && !detailData.invoices?.length && !detailData.credit_notes?.length" class="remit-modal__muted">
						No invoice found for order {{ detailLine.vendor_ref }} on this customer.
					</div>
					<div *ngFor="let inv of detailData.invoices" class="doc">
						<div class="doc__hd">
							<span class="doc__title">Invoice #{{ inv.transno }}</span>
							<span class="doc__meta">{{ inv.date }} · {{ inv.face | currency }}</span>
							<span class="chip" [ngClass]="inv.settled ? 'st-settled' : 'st-matched'">{{ inv.settled ? 'settled' : 'open · ' + (inv.balance | currency) }}</span>
						</div>
						<div class="doc__rows" *ngIf="inv.settled_by?.length">
							<div class="drow" *ngFor="let p of inv.settled_by">
								<span class="drow__date">{{ p.date }}</span>
								<span class="drow__by"><b>{{ p.doc }}</b><ng-container *ngIf="p.by"> · {{ p.by }}</ng-container></span>
								<span class="drow__ref">#{{ p.transno }}</span>
								<span class="drow__amt">{{ p.amount | currency }}</span>
							</div>
						</div>
						<div *ngIf="!inv.settled_by?.length" class="remit-modal__muted doc__empty">No payments applied yet.</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
